import { Pipe, PipeTransform } from '@angular/core';
import { BlocÉtat } from '../models/bloc-état';

@Pipe({
  name: 'convertBlocEtatToString',
})
export class ConvertBlocEtatToStringPipe implements PipeTransform {
  transform(value?: BlocÉtat): string {
    if (!value) {
      return '';
    }
    switch (value) {
      case BlocÉtat.A_FAIRE:
        return 'Croisement à faire';
      case BlocÉtat.EN_COURS:
        return 'Croisement en cours';
      case BlocÉtat.FAIT:
        return 'Croisement fait';
    }
  }
}
